/***
 * ================================================
 *   WICHTIGER MERKSATZ
 * ================================================
 *  ELTERNELEMENT hat aktion:statement[@check=XXXX]
 * dann muss das kind: previousStatement:""XXXX" haben
 * außerdem erlaubt das eliern element ____ALLE____ anderen
 * typen die previousStatement:null <-- DEFAULT haben
 * ================================================
 */



export const BLOCKLY_LABEL_ACTIONS: BlocklyToolboxLabel = { kind: 'label', text: 'Aktionen' };
export const BLOCKLY_LABEL_STYLINGS: BlocklyToolboxLabel = { kind: 'label', text: 'Style' };

export const BLOCKLY_LABEL_CARDS: BlocklyToolboxLabel = { kind: 'label', text: 'Chatinhalte' };
export const BLOCKLY_LABEL_PROPERTES: BlocklyToolboxLabel = { kind: 'label', text: 'Eigenschaften' };
export const BLOCKLY_LABEL_EVENTS: BlocklyToolboxLabel = { kind: 'label', text: 'Ereignisse' };


export const BLOCKLY_DUMMY = {
  URL: "DUMMY_URL",
  VARIABLES: "RAGAI_GET_VAR",
  STRING: "DUMMY_STRING",
  RAGAIOBJ: "RAGAIOBJ",
  SECONDS: "TIME_SECONDS",
  NUMBER: "DUMMY_NUMBER",
  BOOLEAN: "DUMMY_BOOLEAN",
  COMPLETIONMESSAGECONTENT_TEXT: "COMPLETIONCONTENT_TEXT",
  COMPLETIONMESSAGECONTENT_IMAGE: "COMPLETIONCONTENT_IMAGE",
  COMPLETIONMESSAGE: "COMPLETION_MSG"
};



//FFCC32 GELB
export const BLOCKLY_COLORS = {
  // Category Group Colors
  CAT_START_ABLAUF: "#2E7E32",
  CAT_CHAT_AUSGABE: "#536DFE",
  CAT_EREIGNISSE: "#4CAF50",
  CAT_KI_FUNKTIONEN: "#7E57C2",
  CAT_DATEN_INHALTE: "#E53935",
  CAT_DARSTELLUNG: "#FF6D04",
  CAT_INTEGRATIONEN: "#00796B",
  CAT_LOGIK_CODE: "#303F9F",

  DIALOGRECORDER: "#ed9292",
  PLUGIN: "#00A6D6",
  FUSION: "#FF6D04",
  BOTVIEW: undefined,
  MAIL: "#1D87F5",
  MESSAGES: "#5B80A5",
  MESSAGES_LIGHT: "#8DA6C1",
  CARDS: "#5B80A5",
  CODE: "#000000",
  OVERLAYS: "#5C6BC0",
  TOASTR: "#7E57C2",
  BUTTONS: "#536DFE",
  DEPRECATED: '#C5C5C5',
  PRIMARY: "#00A599",
  GENERAL: "#000000",
  STYLING: "#F89E00",

  VARIABLES: "#ff6d04",
  QUIZ: "#1D87F5",
  QUIZ_LIGHT: "#68a1dfb4",
  RAGAI: "#7D8799",
  RAGAI_DARK: "#676f7d",
  EVENTS: "#00A599",
  EVENTS_LIGHT: "#33B8AB",
  BEFORE_SEND: "#546E7A",
  BEFORE_SEND_LIGHT: "#78909C",
  CHAINS: "#5BA55B",
  CHAINS_LIGHT: "#70d370",
  IF: "#4C97FF",
  IF_CONDITION: "#5BA5F8",
  IF_OPERATION: "#3A78D0",
  LOOP: "#157be0",
  STAGES: undefined,
  SKILLS: '#5BA55B',
  SCORES: undefined,
  WENNDANN: "#F89E00",
  PROPERTIES: "#FFCC32",
  ACTIONS: "#E53935",
};

export const BLOCKLY_CARD_PREFIX = {
  AI_HELPERS: "\n🤖 ",
  IMAGE: "🖼️",
  IFRAME: "🌐",
  HTML: "<HTML />",
  YOUTUBE: "youtube 🎬",
  VIMEO: "vimeo 🎬",
  WAITFOR: "⏸️ ",
  BUTTONS: "🎛️ ",
}

/**
 * Erhellt oder verdunkelt einen Hex-Farbwert
 * @param color Hex-Farbwert (#XXXXXX)
 * @param percent Prozentsatz: positiv = heller, negativ = dunkler (-100 bis 100)
 * @returns Modifizierter Hex-Farbwert
 */
export function adjustColorBrightness(color: string, percent: number): string {
  const num = parseInt(color.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;
  return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
    (B < 255 ? B < 1 ? 0 : B : 255))
    .toString(16).slice(1);
}

export const BLOCKLY_BLOCK_PREFIX = {
  QUIZ: "",
  MAIL: "📧 ",
  OVERLAYS: "🔲 ",
  TOASTR: "ℹ️ ",
  BUTTONS: "🎛️ ",
  MESSAGES: "💬 ",
  CARDS: "❝%❞",
  ACTIONS: "▶️ ",
  FUSIONS: "🧬 ",
  STYLINGS: "🖌️ ",
  EVENTS: "",
  IF: "🔀 ",
  IF_CONDITION: "❔ ",
  LOOP: "🔄 "
};


export type BlockProperties = {
  output?: string | null; // Output type, e.g. 'String', 'Number', or null for no output
  inputsInline?: boolean; // Whether to display inputs inline
  previousStatement?: string | null; // Type of the previous statement, e.g. 'String'
  nextStatement?: string | null; // Type of the next statement, e.g. 'String'
  connection?: "top" | "bottom" | "none"; // Whether the block has no connections
  colour?: number | string; // Block colour
  colourSecondary?: number | string; // Block colour
  colourTertiary?: number | string; // Block colour
  tooltip?: string; // Tooltip text
  helpUrl?: string; // Help URL,
  hat?: "cap"; // Hat-Block (Start-Block) mit abgerundeter Kappe oben
  icon?: string; // Remix Icon Klasse, z.B. 'ri-home-line' – wird als erstes Icon im Block gerendert
  deprecated?: boolean; // Block ist veraltet und soll nicht in Suche / Hilfe erscheinen
}

export type HiddenFieldDef = {
  name: string;
  argDef: any; // The Blockly arg definition (type, name, value/text/options/check etc.)
  defaultValue: any;
  label?: string; // Optional label text to show before the field
};

export type BlockyJson = {
  type: string,
  message0: string
  args0: unknown[],
  colour: number | string,
  tooltip: string,
  helpUrl?: string,
  inputsInline: boolean,
  output?: string | null, // Output type, e.g. 'String', 'Number', or null for no output
  previousStatement?: string | null,
  nextStatement?: string | null,
  colourSecondary?: number | string; // Block colour
  colourTertiary?: number | string; // Block colour
  hat?: "cap"; // Hat-Block (Start-Block) mit abgerundeter Kappe oben
  mutator?: string; // Mutator extension name
  _hiddenFieldDefs?: HiddenFieldDef[]; // Hidden fields metadata for expand/collapse
};

/*** DAS HAT EIN OUTPUT, es darf KEIN
 * previousStatement haben
 */
export const PROPERTIES_FOR_PROPERTIES: BlockProperties = {
  colour: BLOCKLY_COLORS.PROPERTIES
};


export const PROPERTIES_FOR_STRING_JOIN_ITEM: BlockProperties = {
  colour: BLOCKLY_COLORS.CHAINS_LIGHT,
  previousStatement: 'CHAINITEM',
  nextStatement: 'CHAINITEM'
};

export const PROPERTIES_FOR_DOC_JOIN_ITEM: BlockProperties = {
  colour: BLOCKLY_COLORS.CHAINS_LIGHT,
  previousStatement: 'DOCCHAINITEM',
  nextStatement: 'DOCCHAINITEM'
};

export const PROPERTIES_FOR_CUSTOM_OPTION_ITEM: BlockProperties = {
  colour: BLOCKLY_COLORS.CHAINS_LIGHT,
  previousStatement: 'custom_option_item',
  nextStatement: 'custom_option_item',
  inputsInline: true
};

export const PROPERTIES_FOR_EVENTS: BlockProperties = {
  colour: BLOCKLY_COLORS.EVENTS,
  previousStatement: 'EVENT',
  inputsInline: true
};


export const PROPERTIES_FOR_STYLINGS: BlockProperties = {
  colour: BLOCKLY_COLORS.STYLING,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION'
};

export const PROPERTIES_FOR_FUSION: BlockProperties = {
  colour: BLOCKLY_COLORS.FUSION,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION'
};

export const PROPERTIES_FOR_ACTIONS: BlockProperties = {
  colour: BLOCKLY_COLORS.ACTIONS,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION'
};

export const PROPERTIES_FOR_CARDS: BlockProperties = {
  colour: BLOCKLY_COLORS.CARDS,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION'
};

export const PROPERTIES_FOR_STAGE: BlockProperties = {
  colour: BLOCKLY_COLORS.STAGES,
  previousStatement: 'ACTION'
};

export const PROPERTIES_FOR_RAGAI: BlockProperties = {
  colour: BLOCKLY_COLORS.RAGAI,
  inputsInline: true
};

export const PROPERTIES_FOR_BUTTONS: BlockProperties = {
  colour: BLOCKLY_COLORS.BUTTONS,
  inputsInline: true,
  nextStatement: 'BUTTON',
  previousStatement: 'BUTTON',

};

export const PROPERTIES_FOR_OVERLAYS: BlockProperties = {
  colour: BLOCKLY_COLORS.OVERLAYS,
  inputsInline: true,
  //nextStatement: 'OVERLAY',
  //previousStatement: 'OVERLAY',
};

export const PROPERTIES_FOR_TOASTR: BlockProperties = {
  colour: BLOCKLY_COLORS.TOASTR,
  inputsInline: true,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION',
};

export const PROPERTIES_FOR_QUIZ: BlockProperties = {
  colour: BLOCKLY_COLORS.QUIZ,
  inputsInline: true,
  nextStatement: 'ACTION',
  previousStatement: 'ACTION',
};

export type BlocklyToolboxCategory = {
  kind: 'category'
  colour?: string | number;
  name?: string;
  cssconfig?: { icon?: string; row?: string; container?: string; label?: string; };
  contents?: ({ kind: "block" | "label"; type?: string; text?: string; inputs?: any, [key: string]: any })[];
}

export type BlocklyToolboxLabel = {
  kind: 'label';
  text: string;
}

export type BlocklyToolboxSep = {
  kind: 'sep';
  gap?: number | string; // Optional, meist in px
};

export type BlocklyToolboxItem =
  | BlocklyToolboxCategory
  | BlocklyToolboxLabel
  | BlocklyToolboxSep;
